/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import TableLineIcons from "../../components/TableLineIcons";
import LangContext from "../../contextProvider/LangContext";
import moment from "moment";
import GenericModal from "../../components/GenericModal";
import DateTimePicker from "../../components/DateTimePicker";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import SelectorItemClassic from "../../components/SelectorItemClassic";
import { Button, Col, Form, Radio } from "antd";
import { Row } from "antd/es/grid";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import ReportTypeButton from "../../components/ReportTypeButton";
import { escapeRegExp } from "../../utils/utils";


class InternalOrders extends Component {
    constructor(props: Props) {
        super(props);

        this.clearFilters = {
            _fromOpenDate: null,
            _toOpenDate: null,
            _fromCloseDate: null,
            _toCloseDate: null,
            _posList: "",
            _item: "",
            _itemName: "",
            _statusType: '0',
            _sort_by: "col_1",
            _isAsc: 0,
        };

        this.state = {
            filters: this.clearFilters,
            modalFilters: false,
            modalDetails: null,
            reportCentralBy: "0",
        };

        this.id = "INTERNAL_ORDERS";

        this.api = {
            get: "get_internal_orders",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22477);
    }


    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        const sorter = true;
        const render = t => t;
        const renderDate = t => t ? moment(t).format("DD/MM/YYYY HH:mm") : "";

        const renderSLA = (t) => {
            if (!parseInt(t)) return "";
            let m = moment.duration(t, 'seconds')
            let d = Math.floor(m.asDays())
            const timeStr = moment.utc(m.asMilliseconds()).format("HH:mm");
            return (<>{d ? <>{d} {gt(22485)}<br /></> : ""}{timeStr}</>);
        }

        const renderQty = (t) => {
            let q = t ? t.indexOf(".00") > -1 ? parseInt(t) : parseFloat(t).toFixed(2) : 0;
            return q;
        }

        const renderItem = (t, r) => {
            return (<>
                {r.mItemCode}<br />
                {t} {r.mCloseTimeStamp ? `(${renderQty(r.mCollectedQty)})` : ""}
            </>);
        }

        const renderEdit = (t, r) => (<TableLineIcons
            onDelete={() => {
                this.sendAPI("cancel_collect_list", { mID: r.mID }, () => {
                    this.props.dataActions.genericDataGetRequested(
                        this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
                })
            }}
            deleteQuetion={{ title: gt(22487), okText: gt(22488), cancelText: gt(22489) }}
            genericIcons={[
                {
                    type: "eye",
                    onClick: () => { this.setState({ modalDetails: r }) },
                    tooltip: gt(22486),
                }
            ]}
        />)

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                filters={this.state.filters}
                title={gt(22477)}
                rowHeight={50}
                searchBox
                columns={[
                    { title: gt(22478), key: "mOpenTimeStamp", dataIndex: "mOpenTimeStamp", width: "15%", sorter, render: renderDate },
                    { title: gt(22479), key: "mCloseTimeStamp", dataIndex: "mCloseTimeStamp", width: "15%", sorter, render: renderDate },
                    { title: gt(22480), key: "mSLA", dataIndex: "mSLA", width: "15%", sorter, render: renderSLA },
                    { title: gt(22481), key: "mBranchName", dataIndex: "mBranchName", width: "15%", sorter, render: (t, r) => (<>{r.mBranchId}<br />{t}</>) },
                    { title: gt(22482), key: "mPosName", dataIndex: "mPosName", width: "15%", sorter, render: (t, r) => (<>{r.mDocPosId}<br />{t}</>) },
                    { title: gt(22483), key: "mItemDesc", dataIndex: "mItemDesc", width: "15%", sorter, render: renderItem },
                    { title: gt(22484), width: "10%", render: renderEdit },
                ]}
                actionButtons={[
                    { buttonType: 'filter', buttonFunction: () => { this.setState({ modalFilters: true }) } },
                    { buttonType: 'print', buttonFunction: () => { this.setState({ modalReport: true }) } },
                ]}
            />
            <GenericModal
                visible={this.state.modalFilters}
                onCancel={() => this.setState({ modalFilters: false })}
                title={gt(22490)}
                width={600}
                footer={[
                    <Button key="back" onClick={() => this.setState({ modalFilters: false })}>{gt(22491)}</Button>,
                    <Button key="clear" onClick={() => this.setState({ filters: this.clearFilters })}>{gt(22492)}</Button>,
                    <Button key="filter" type="primary" onClick={() => {
                        this.setState({ modalFilters: false }, () => {
                            this.props.dataActions.genericDataSetFilter(
                                this.id, this.props.user.companyCode, this.props.user.token, {
                                ...this.state.filters,
                                page: 1,
                                _page_num: 1,
                            }, this.api.get);
                        });
                    }}>{gt(22493)}</Button>,
                ]}
            >
                <Form.Item label={gt(22494)}>
                    <Form.Item label={gt(22495)} style={{ display: "inline-block", margin: "0 8px" }}>
                        <DateTimePicker
                            format="DD/MM/YYYY"
                            value={this.state.filters._fromOpenDate}
                            onChange={(e) => {
                                this.setState({ filters: { ...this.state.filters, _fromOpenDate: e } })
                            }}
                            maxDate={this.state.filters._toOpenDate} />
                    </Form.Item>
                    <Form.Item label={gt(22496)} style={{ display: "inline-block", margin: "0 8px" }}>
                        <DateTimePicker
                            format="DD/MM/YYYY"
                            value={this.state.filters._toOpenDate}
                            onChange={(e) => {
                                this.setState({ filters: { ...this.state.filters, _toOpenDate: e } })
                            }}
                            minDate={this.state.filters._fromOpenDate} />
                    </Form.Item>
                </Form.Item>
                <Form.Item label={gt(22497)}>
                    <Form.Item label={gt(22495)} style={{ display: "inline-block", margin: "0 8px" }}>
                        <DateTimePicker
                            format="DD/MM/YYYY"
                            value={this.state.filters._fromCloseDate}
                            onChange={(e) => {
                                this.setState({ filters: { ...this.state.filters, _fromCloseDate: e } })
                            }}
                            maxDate={this.state.filters._toCloseDate}
                        />
                    </Form.Item>
                    <Form.Item label={gt(22496)} style={{ display: "inline-block", margin: "0 8px" }}>
                        <DateTimePicker
                            format="DD/MM/YYYY"
                            value={this.state.filters._toCloseDate}
                            onChange={(e) => {
                                this.setState({ filters: { ...this.state.filters, _toCloseDate: e } })
                            }}
                            minDate={this.state.filters._fromCloseDate} />
                    </Form.Item>
                </Form.Item>
                <Row>
                    <Col span={16}>
                        <Form.Item label={gt(22498)}>
                            <GenericSelectorPosStorages
                                {...this.props} multi
                                value={this.state.filters._posList ? this.state.filters._posList.split(",") : []}
                                onChange={(e) => this.setState({ filters: { ...this.state.filters, _posList: e ? e.join(",") : "" } })} />
                        </Form.Item>
                        <Form.Item label={gt(22504)}>
                            <SelectorItemClassic
                                {...this.props}
                                valueId={this.state.filters._item}
                                valueName={this.state.filters._itemName}
                                onChange={(_item, _itemName) => {
                                    this.setState({ filters: { ...this.state.filters, _item, _itemName } })
                                }} />
                        </Form.Item>
                    </Col>
                    <Col span={8} style={{ paddingRight: 50 }}>
                        <Form.Item label={gt(22499)}>
                            <Radio.Group
                                onChange={(e) => {
                                    this.setState({ filters: { ...this.state.filters, _statusType: e.target.value } })
                                }}
                                value={this.state.filters._statusType}>
                                <Radio value={'0'}>{gt(22500)}</Radio><br />
                                <Radio value={'1'}>{gt(22501)}</Radio><br />
                                <Radio value={'2'}>{gt(22502)}</Radio><br />
                                <Radio value={'3'}>{gt(22503)}</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>

            </GenericModal>
            <GenericModal
                visible={this.state.modalDetails}
                onCancel={() => this.setState({ modalDetails: null })}
                title={gt(22505)}
                width={400}
                footer={[
                    <Button key="back" onClick={() => this.setState({ modalDetails: null })}>{gt(22506)}</Button>,
                ]}
            >
                {this.state.modalDetails && <>
                    <p><b>{gt(22507)}:</b> {this.state.modalDetails.mID}</p>
                    <p><b>{gt(22508)}:</b> {this.state.modalDetails.mDocNum}</p>
                    <p><b>{gt(22509)}:</b> {renderDate(this.state.modalDetails.mOpenTimeStamp)}</p>
                    <p><b>{gt(22510)}:</b> {renderDate(this.state.modalDetails.mUpdateTimeStamp)}</p>
                    <p><b>{gt(22511)}:</b> {renderDate(this.state.modalDetails.mCloseTimeStamp)}</p>

                    <p><b>{gt(22512)}:</b> {this.state.modalDetails.mCloseEmployeeID} - {this.state.modalDetails.mCloseEmployeeName}</p>
                    <p><b>{gt(22513)}:</b> {renderQty(this.state.modalDetails.mRequiredQty)}</p>
                    <p><b>{gt(22514)}:</b> {renderQty(this.state.modalDetails.mCollectedQty)}</p>
                </>}
            </GenericModal>
            <GenericModal visible={this.state.modalReport}
                onCancel={() => this.setState({ modalReport: false })}
                title={gt(22515)}
                width={600}
            >
                <Form.Item label={gt(22519)}>
                    <Radio.Group
                        value={this.state.reportCentralBy}
                        onChange={(e) => this.setState({ reportCentralBy: e.target.value })}>
                        <Radio value={'0'}>{gt(22520)}</Radio><br />
                        <Radio value={'1'}>{gt(22521)}</Radio><br />
                        <Radio value={'2'}>{gt(22522)}</Radio><br />
                        <Radio value={'3'}>{gt(22523)}</Radio><br />
                        <Radio value={'4'}>{gt(22524)}</Radio><br />
                        <Radio value={'5'}>{gt(22525)}</Radio><br />
                    </Radio.Group>
                </Form.Item>

                <ReportTypeButton
                    {...this.props}
                    params={{
                        ...this.state.filters,
                        _words: escapeRegExp(this.props.data[this.id].filters._words),
                        _page_num: 1,
                        _rows_num: 9999999,
                        _sort_by: 'col_1' + (this.state.reportCentralBy > 0 ? this.state.reportCentralBy : ''),
                        _isAsc: 0,
                        reportName: "reports/InternalOrders.pdf"
                    }}
                    encodeURIFields={["_words", "_item", "_itemName", "_posList"]}
                    posField={"_posList"}
                    datesToFavorites={[
                        { field: '_fromOpenDate', label: gt(17991) },
                        { field: '_toOpenDate', label: gt(17992) },
                        { field: '_fromCloseDate', label: gt(17991) },
                        { field: '_toCloseDate', label: gt(17992) },
                    ]}
                    xlsReportName={"reports/InternalOrdersExcel.xlsx"}
                    favoriteSave
                />
            </GenericModal>
        </div>)
    }

}

export default InternalOrders;